// extracted by mini-css-extract-plugin
module.exports = {"highlightText":"HighlightText_highlightText__bGrWa","highlightText__text":"HighlightText_highlightText__text__VFSHl"};